import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import assest from "../../json/assest";
// import Image from "next/image";
import styles from "../../styles/layout/Sidebar/contenybuyer-dashboard-sidebar.module.scss";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    List,
    ListItem,
    Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useNotiStack from "../../hooks/useNotistack";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { logout } from "../../redux-toolkit/slices/userSlice";
// import { useRouter } from "next/router";
import MenuDashboardIcon from "../../ui/Icons/MenuDashboardIcon";
import MenuClearVideoIcon from "../../ui/Icons/MenuClearVideoIcon";
import MenuNotification from "../../ui/Icons/MenuNotification";
import MenuMyMessageIcon from "../../ui/Icons/MenuMyMessageIcon";
import AccountingIconLg from "../../ui/Icons/AccountingIconLg";
import SidebarUserIcon from "../../ui/Icons/SidebarUserIcon";
import PurchaseSolidIcon from "../../ui/Icons/PurchaseSolidIcon";
import { useLocation, useNavigate } from "react-router-dom";

const menuItems = [
    {
        heading: "Dashboard",
        icon: <MenuDashboardIcon />,
        link: "/content-buyer-dashboard",
    },
    {
        heading: "Purchase Requests",
        icon: <PurchaseSolidIcon />,
        link: "/content-buyer-dashboard/purchase-request",
    },
    {
        heading: "Purchased Videos",
        icon: <MenuClearVideoIcon />,
        link: "/content-buyer-dashboard/purchase-videos",
    },
    {
        heading: "Accounting",
        icon: <AccountingIconLg />,
        link: "/content-buyer-dashboard/accounting",
    },
    {
        heading: "Notifications",
        icon: <MenuNotification />,
        link: "/content-buyer-dashboard/notification",
    },

    {
        heading: "My Messages",
        icon: <MenuMyMessageIcon />,
        subMenuItems: [
            {
                heading: "Messages",
                icon: assest.messageIcon,
                link: "/content-buyer-dashboard/message",
            },
            {
                heading: "Support",
                icon: assest.supportIcon,
                link: "/content-buyer-dashboard/support",
            },
        ],
        // link: "/",
    },
    {
        heading: "My Account",
        icon: <SidebarUserIcon />,
        link: "/",
    },
];

const UserSidebar = () => {
    const { toastSuccess } = useNotiStack();
    const dispatch = useAppDispatch();
    const [drop, setDrop] = useState(false);
    const [expanded, setExpanded] = React.useState(false);

    const handleChange =
        (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

    const logoutFunc = () => {
        dispatch(logout());
        // toastSuccess("Logout Successful");
    };

    const router = useLocation();
    const routePush = useNavigate()
    const scrollBarRef = useRef(null);
    useEffect(() => {
        const elementSelector = document.querySelectorAll(
            `.custom_scl a[href="${router.pathname}"]`
        );
        if (scrollBarRef.current && elementSelector?.[0]) {
            const boundingRect = elementSelector?.[0]?.getBoundingClientRect();
            scrollBarRef.current.scrollTop = boundingRect.top;
        }
    }, [router.pathname]);
    return (
        <Box className={styles.sidebar_menu_box}>
            <Box className={styles.sidebar_menu}>
                <Box className={styles.sidebar_menu_inner}>
                    <PerfectScrollbar
                        className="custom_scl"
                        containerRef={(container) => {
                            scrollBarRef.current = container;
                        }}
                    >
                        <List>
                            {menuItems?.map((menu, index) => {
                                const hasSubMenu =
                                    menu?.subMenuItems && menu?.subMenuItems?.length > 0;
                                const path = menu?.link;
                                let isActive = false;
                                if (path) {
                                    if (path === "/") {
                                        if (router.pathname === "/") {
                                            isActive = true;
                                        }
                                    } else {
                                        isActive = router.pathname.includes(path);
                                    }
                                }
                                if (hasSubMenu) {
                                    menu?.subMenuItems?.some((subMenu) => {
                                        if (subMenu.link) {
                                            if (subMenu.link === "/") {
                                                if (router.pathname === "/") {
                                                    isActive = true;
                                                }
                                            } else {
                                                isActive = router.pathname.includes(subMenu.link);
                                            }
                                            return isActive;
                                        }
                                    });
                                }
                                return (
                                    <ListItem className={`${isActive ? styles.active_menu : ""} ${menu.heading === "Content Buyers" ? styles.badge : ""}`}>
                                        <a
                                            href={menu?.link || "#"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (!hasSubMenu && menu.link) {
                                                    routePush(menu.link);
                                                }
                                            }}

                                        >
                                            <figure className={styles.side_menu}>
                                                {menu?.icon}
                                            </figure>
                                            {!hasSubMenu ? (
                                                <Typography
                                                    variant="caption"
                                                    className={styles.menuName}
                                                >
                                                    {menu?.heading}
                                                </Typography>
                                            ) : null}
                                        </a>
                                        {hasSubMenu ? (
                                            <Accordion
                                                expanded={expanded === "panel" + index || isActive}
                                                onChange={handleChange("panel" + index)}
                                            >
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    {menu.heading}
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <List className={styles.submenuList}>
                                                        {menu?.subMenuItems?.map((subMenu) => {
                                                            let subMenuActive = false;
                                                            if (subMenu.link) {
                                                                if (subMenu.link === "/") {
                                                                    if (router.pathname === "/") {
                                                                        subMenuActive = true;
                                                                    }
                                                                } else {
                                                                    subMenuActive = router.pathname.includes(
                                                                        subMenu.link
                                                                    );
                                                                }
                                                            }
                                                            return (
                                                                <ListItem
                                                                    className={`${subMenuActive ? styles.submenu_active : ""} ${subMenu.heading === "Purchase Requests" ? styles.innerBadge : ""}`}
                                                                >
                                                                    <a
                                                                        href={subMenu?.link || "#"}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            if (subMenu.link) {
                                                                                routePush(subMenu.link);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <figure>
                                                                            <img
                                                                                src={subMenu?.icon}
                                                                                alt="img"
                                                                                width={10}
                                                                                height={10}
                                                                            />
                                                                        </figure>
                                                                        <Typography variant="caption">
                                                                            {subMenu?.heading}
                                                                        </Typography>
                                                                    </a>
                                                                </ListItem>
                                                            );
                                                        })}
                                                    </List>
                                                </AccordionDetails>
                                            </Accordion>
                                        ) : null}
                                    </ListItem>
                                );
                            })}

                            <ListItem className={styles.logout_btn} onClick={logoutFunc}>
                                <figure className={styles.side_menu}>
                                    <img
                                        src={assest.menuicon15}
                                        alt=""
                                        width={23}
                                        height={20}
                                    />
                                </figure>
                                <Typography variant="caption" className={styles.menuName}>
                                    Logout
                                </Typography>
                            </ListItem>
                        </List>
                    </PerfectScrollbar>
                </Box>
            </Box>
        </Box>
    );
};

export default UserSidebar;
